var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-sortable-hoc/~/lodash/_Symbol.js
// module id = 379
// module chunks = 4